import axios from 'axios';
import { API_PREFIX } from 'config';

const instance = axios.create({
  baseURL: API_PREFIX,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const setHeaders = ({ accessToken, idToken }) => {
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  axios.defaults.headers.common['id-token'] = idToken;
};

export const clearHeaders = () => {
  delete axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common['id-token'];
};

export default instance;
